"use client";

import { useState, useEffect } from "react";

const useIsMobile = (breakpoint = 1140) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Prevent running on the server
    if (typeof window === "undefined") return;

    const updateIsMobile = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    // Check on component mount (client-side only)
    updateIsMobile();

    // Add event listener for window resize
    window.addEventListener("resize", updateIsMobile);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", updateIsMobile);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
